import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { SingleProjectToTargetComponentBase } from 'common-ui';

@Component({
  selector: 'ideal-render-target-product-result-stock',
  standalone: true,
  imports: [],
  template: ``,
  styles: `
    :host {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      gap: 0.3em;
    }
    :host ::ng-deep > * {
      flex: 0 0 100%;
      order: 1000;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductResultStockRenderTargetComponent extends SingleProjectToTargetComponentBase {
  public override readonly context = undefined;
  protected readonly renderInElements = computed(() => this.renderNodes().map((node) => this.element));
}
